export default () => new Promise((resolve) => {
    if (window.Stripe) {
        resolve()
    }

    const script = document.createElement('script')
    script.src = 'https://js.stripe.com/v3/'

    document.body.appendChild(script)

    script.onload = () => {
        resolve()
    }
})
